import React, { Component } from "react";
import { Redirect } from "react-router";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBIcon } from "mdbreact";
import API_URL from "../config";
import axios from "axios";

class AdminDeclaracionesJuradas extends Component {
  state = {
    anio: new Date().getFullYear().toString(),
    calendarios: [],
    cargando: false,
    mostrarFormulario: false,
    editando: false,
    documento: "",
    nombre: "",
    anioFormulario: new Date().getFullYear().toString(),
    fechaInicio: new Date().toISOString().substring(0, 10),
    fechaFin: (function() { var d = new Date(); d.setDate(d.getDate() + 7); return d.toISOString().substring(0, 10); })(),
    estado: "A",
    porTrabajador: "",
    tiposPlanilla: [],
    planillasSeleccionadas: [],
    modalExito: "",
    modalError: "",
    volverPanel: false,
    irValidar: null,
    modalConfirmarEliminar: null,
    trabajadoresPlanilla: [],
    totalTrabajadores: 0,
    cargandoTrabajadores: false,
    busquedaTrabajador: "",
    sugerencias: [],
    trabajadoresSeleccionados: [],
    cargandoBusqueda: false,
    mostrarSugerencias: false,
    modoAsignacion: "PLANILLA",
    aniosDisponibles: [new Date().getFullYear().toString()],
    notificarCorreo: true,
    enviarPrueba: false,
    correoPrueba: "respaldo.remuneraciones@unsaac.edu.pe",
    enviandoPrueba: false,
    resultadoPrueba: null,
    modalConfirmarGuardar: false,
    notificandoRecordatorio: null,
    resultadoRecordatorio: null,
    modalEstadoRecordatorio: null,
    cargandoEstadoRecordatorio: false,
    trabajadoresYaNotificados: [],
    cargandoNotificados: false
  };

  getToken = function () {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem("datos")); } catch (e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  };

  getDatos = function () {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem("datos")); } catch (e) { datos = null; } }
    return datos;
  };

  componentDidMount() {
    var datos = this.getDatos();
    if (datos) { sessionStorage.setItem("datos", JSON.stringify(datos)); }
    this.cargarTiposPlanilla();
    this.cargarAniosDisponibles();
    this.buscarCalendarios();
  }

  cargarAniosDisponibles = function () {
    axios.post(API_URL + "/admin/aniosdisponibles/", {})
      .then(function (r) { if (r.data && r.data.length > 0) this.setState({ aniosDisponibles: r.data }); }.bind(this))
      .catch(function () {});
  };

  cargarTiposPlanilla = function () {
    var token = this.getToken();
    if (!token) return;
    axios.post(API_URL + "/admin/listartiposplanilla/", {
      method: "post", credentials: "same-origin", mode: "cors",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" },
      body: JSON.stringify({ autorizacion: token })
    })
    .then(function (response) {
      var planillas = response.data || [];
      this.setState({ tiposPlanilla: planillas.filter(function (p) { return p.regular && p.regular.trim() === "SI"; }) });
    }.bind(this))
    .catch(function (err) { console.error(err); });
  };

  buscarCalendarios = function () {
    var token = this.getToken();
    if (!token) return;
    this.setState({ cargando: true, mostrarFormulario: false, editando: false });
    axios.post(API_URL + "/admin/listarcalendarios/", {
      method: "post", credentials: "same-origin", mode: "cors",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" },
      body: JSON.stringify({ autorizacion: token, anio: this.state.anio })
    })
    .then(function (response) {
      this.setState({ calendarios: response.data || [], cargando: false });
    }.bind(this))
    .catch(function (err) { console.error(err); this.setState({ cargando: false }); }.bind(this));
  };

  guardarCalendario = function () {
    var token = this.getToken();
    if (!token) return;
    var sinDestinatarios = this.state.planillasSeleccionadas.length === 0 && this.state.trabajadoresSeleccionados.length === 0;
    if (!this.state.documento.trim() || !this.state.fechaInicio || !this.state.fechaFin || sinDestinatarios) {
      this.setState({ modalError: "Complete los campos obligatorios: Tipo de declaración, Año, Fecha inicio, Fecha fin y al menos un Tipo de planilla o un trabajador específico." });
      return;
    }
    if (new Date(this.state.fechaFin) <= new Date(this.state.fechaInicio)) {
      this.setState({ modalError: "La fecha de fin debe ser posterior a la fecha de inicio." });
      return;
    }
    this.setState({ cargando: true });
    axios.post(API_URL + "/admin/guardarcalendario/", {
      method: "post", credentials: "same-origin", mode: "cors",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" },
      body: JSON.stringify({
        autorizacion: token,
        anio: this.state.anioFormulario,
        documento: this.state.documento.trim(),
        nombre: this.state.documento.trim(),
        fechadeinicio: this.state.fechaInicio + " 00:00:00",
        fechadefin: this.state.fechaFin + " 23:59:59",
        estado: this.state.estado,
        tituloUno: "",
        tituloDos: "",
        tituloTres: "",
        observacion: this.state.planillasSeleccionadas.join(","),
        descripcion: this.state.trabajadoresSeleccionados.map(function (t) { return t.DNI || ""; }).join(",")
      })
    })
    .then(function () {
      var anioGuardado = this.state.anioFormulario;
      var esEdicion = this.state.editando;
      var notificar = this.state.notificarCorreo;
      var docGuardado = this.state.documento.trim();
      var anioFinal = this.state.anioFormulario;
      var payloadApertura = (!esEdicion && notificar) ? {
        documento: docGuardado, anio: anioFinal, nombre: docGuardado,
        fechaFin: this.state.fechaFin, esEdicion: false,
        observacion: this.state.planillasSeleccionadas.join(","),
        descripcion: this.state.trabajadoresSeleccionados.map(function(t){ return t.DNI || ""; }).join(",")
      } : null;
      // Edicion: notificar solo a trabajadores nuevos (no estaban en TaNotificacionDJ)
      var yaNotif = this.state.trabajadoresYaNotificados;
      var todosActuales = this.state.trabajadoresPlanilla.concat(this.state.trabajadoresSeleccionados).filter(function(t, i, arr) {
        return arr.findIndex(function(x){ return x.CodigoTrabajador === t.CodigoTrabajador; }) === i;
      });
      var nuevosANotificar = todosActuales.filter(function(t) { return yaNotif.indexOf(t.CodigoTrabajador) === -1; });
      var payloadNuevos = (esEdicion && notificar && nuevosANotificar.length > 0) ? {
        documento: docGuardado, anio: anioFinal, nombre: docGuardado,
        fechaFin: this.state.fechaFin, esEdicion: true,
        descripcion: nuevosANotificar.map(function(t){ return t.DNI || ""; }).join(",")
      } : null;
      this.setState({ modalExito: esEdicion ? "Declaración jurada actualizada correctamente." : "Declaración jurada creada correctamente.", anio: anioGuardado, mostrarFormulario: false, editando: false, documento: "", nombre: "", porTrabajador: "", planillasSeleccionadas: [] }, function() {
        this.buscarCalendarios();
      }.bind(this));
      var token = this.getToken();
      if (payloadApertura) {
        axios.post(API_URL + "/admin/notificarapertura/", payloadApertura, { headers: { Authorization: token } })
          .then(function(r) {
            if (r.data && r.data.ok && (r.data.iniciando || r.data.enviados > 0)) {
              this.setState({ modalExito: "Declaración jurada creada correctamente.\nNotificación enviándose a " + r.data.total + " trabajador(es) en segundo plano." });
            } else if (r.data && !r.data.ok) {
              this.setState({ modalError: "Declaración guardada, pero error al notificar: " + (r.data.error || "desconocido") });
            }
          }.bind(this))
          .catch(function() { this.setState({ modalError: "Declaración guardada, pero no se pudo enviar la notificación." }); }.bind(this));
      }
      if (payloadNuevos) {
        axios.post(API_URL + "/admin/notificarapertura/", payloadNuevos, { headers: { Authorization: token } })
          .then(function(r) {
            if (r.data && r.data.ok && (r.data.iniciando || r.data.enviados > 0)) {
              this.setState({ modalExito: "Declaración actualizada.\nNotificación enviándose a " + r.data.total + " trabajador(es) nuevo(s) en segundo plano." });
            } else if (r.data && !r.data.ok) {
              this.setState({ modalError: "Declaración actualizada, pero error al notificar a nuevos: " + (r.data.error || "desconocido") });
            }
          }.bind(this))
          .catch(function() { this.setState({ modalError: "Declaración actualizada, pero no se pudo notificar a los nuevos." }); }.bind(this));
      }
    }.bind(this))
    .catch(function (err) {
      console.error(err);
      this.setState({ modalError: "Error al guardar la declaración jurada.", cargando: false });
    }.bind(this));
  };

  seleccionarCalendario = function (cal) {
    var fi = cal.fechadeinicio ? cal.fechadeinicio.trim().substring(0, 10) : "";
    var ff = cal.fechadefin ? cal.fechadefin.trim().substring(0, 10) : "";
    var token = this.getToken();
    this.setState({
      mostrarFormulario: true, editando: true,
      anioFormulario: cal.anio || this.state.anio,
      documento: cal.documento || "", nombre: cal.documento || "",
      fechaInicio: fi, fechaFin: ff, estado: cal.estado || "A",
      modoAsignacion: "PLANILLA",
      porTrabajador: "", planillasSeleccionadas: [],
      trabajadoresPlanilla: [], totalTrabajadores: 0,
      trabajadoresSeleccionados: [], busquedaTrabajador: "", sugerencias: [],
      notificarCorreo: false, enviarPrueba: false, resultadoPrueba: null,
      trabajadoresYaNotificados: [], cargandoNotificados: true
    }, function () {
      var anioEdicion = cal.anio || this.state.anio;
      axios.post(API_URL + "/admin/obtenerdetallecalendario/",
        { documento: cal.documento, anio: anioEdicion },
        { headers: { Authorization: token } }
      ).then(function (r) {
        if (r.data) {
          var planillas = r.data.planillas || [];
          var trabajadores = r.data.trabajadores || [];
          this.setState({ planillasSeleccionadas: planillas, trabajadoresSeleccionados: trabajadores });
          if (planillas.length > 0) this.consultarTrabajadores(planillas);
        }
      }.bind(this)).catch(function () {});
      axios.post(API_URL + "/admin/trabajadoresnotificados/",
        { documento: cal.documento, anio: anioEdicion },
        { headers: { Authorization: token } }
      ).then(function (r) {
        this.setState({ trabajadoresYaNotificados: (r.data && r.data.notificados) || [], cargandoNotificados: false });
      }.bind(this)).catch(function () { this.setState({ cargandoNotificados: false }); }.bind(this));
    }.bind(this));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  limpiarFormulario = function () {
    this.setState({
      mostrarFormulario: false, editando: false,
      documento: "", nombre: "", anioFormulario: new Date().getFullYear().toString(), fechaInicio: new Date().toISOString().substring(0, 10), fechaFin: (function() { var d = new Date(); d.setDate(d.getDate() + 7); return d.toISOString().substring(0, 10); })(), estado: "A",
      modoAsignacion: "PLANILLA", porTrabajador: "", planillasSeleccionadas: [],
      trabajadoresPlanilla: [], totalTrabajadores: 0,
      trabajadoresSeleccionados: [], busquedaTrabajador: "", sugerencias: [],
      notificarCorreo: true, enviarPrueba: false, correoPrueba: "respaldo.remuneraciones@unsaac.edu.pe", enviandoPrueba: false, resultadoPrueba: null,
      modalConfirmarGuardar: false
    });
  };

  togglePlanilla = function (codigo) {
    var sel = this.state.planillasSeleccionadas.slice();
    var idx = sel.indexOf(codigo);
    if (idx >= 0) { sel.splice(idx, 1); } else { sel.push(codigo); }
    this.setState({ planillasSeleccionadas: sel }, function () {
      this.consultarTrabajadores(sel);
    }.bind(this));
  };

  consultarTrabajadores = function (tipos) {
    if (!tipos || tipos.length === 0) {
      this.setState({ trabajadoresPlanilla: [], totalTrabajadores: 0 });
      return;
    }
    this.setState({ cargandoTrabajadores: true });
    axios.post(API_URL + "/admin/trabajadoresporplanilla/", { tipos: tipos })
      .then(function (response) {
        this.setState({
          trabajadoresPlanilla: response.data.trabajadores || [],
          totalTrabajadores: response.data.total || 0,
          cargandoTrabajadores: false
        });
      }.bind(this))
      .catch(function () {
        this.setState({ cargandoTrabajadores: false });
      }.bind(this));
  };

  onBusquedaChange = function (valor) {
    this.setState({ busquedaTrabajador: valor, mostrarSugerencias: true });
    clearTimeout(this._busquedaTimer);
    if (valor.trim().length < 2) { this.setState({ sugerencias: [] }); return; }
    this._busquedaTimer = setTimeout(function () {
      this.setState({ cargandoBusqueda: true });
      axios.post(API_URL + "/admin/buscartrabajador/", { texto: valor.trim() })
        .then(function (r) { this.setState({ sugerencias: r.data || [], cargandoBusqueda: false }); }.bind(this))
        .catch(function () { this.setState({ cargandoBusqueda: false }); }.bind(this));
    }.bind(this), 350);
  };

  seleccionarSugerencia = function (trabajador) {
    var ya = this.state.trabajadoresSeleccionados.find(function (t) { return t.CodigoTrabajador === trabajador.CodigoTrabajador; });
    if (!ya) {
      this.setState(function (prev) { return { trabajadoresSeleccionados: prev.trabajadoresSeleccionados.concat([trabajador]) }; });
    }
    this.setState({ busquedaTrabajador: "", sugerencias: [], mostrarSugerencias: false });
  };

  quitarTrabajador = function (codigo) {
    this.setState(function (prev) {
      return { trabajadoresSeleccionados: prev.trabajadoresSeleccionados.filter(function (t) { return t.CodigoTrabajador !== codigo; }) };
    });
  };

  enviarCorreoPrueba = function () {
    var token = this.getToken();
    if (!token) return;
    var correo = this.state.correoPrueba.trim();
    if (!correo) return;
    this.setState({ enviandoPrueba: true, resultadoPrueba: null });
    axios.post(API_URL + "/admin/enviarcorreoprueba/",
      {
        correo: correo,
        nombreDeclaracion: this.state.documento || "AGUINALDO-JULIO",
        anio: this.state.anioFormulario || new Date().getFullYear().toString(),
        fechaFin: this.state.fechaFin || ""
      },
      { headers: { Authorization: token } }
    )
    .then(function (r) {
      this.setState({ enviandoPrueba: false, resultadoPrueba: r.data, enviarPrueba: r.data && r.data.ok ? false : this.state.enviarPrueba });
    }.bind(this))
    .catch(function () { this.setState({ enviandoPrueba: false, resultadoPrueba: { ok: false, error: "Error de conexion" } }); }.bind(this));
  };

  notificarRecordatorio = function (cal) {
    var token = this.getToken();
    if (!token) return;
    this.setState({ notificandoRecordatorio: cal.documento });
    axios.post(API_URL + "/admin/estadorecordatorio/",
      { documento: cal.documento, anio: cal.anio },
      { headers: { Authorization: token } }
    )
    .then(function (r) {
      this.setState({ notificandoRecordatorio: null, modalEstadoRecordatorio: r.data && r.data.ok ? Object.assign({}, r.data, { cal: cal }) : null });
      if (!r.data || !r.data.ok) this.setState({ resultadoRecordatorio: { ok: false, error: r.data ? r.data.error : "Error al consultar estado" } });
    }.bind(this))
    .catch(function () {
      this.setState({ notificandoRecordatorio: null, resultadoRecordatorio: { ok: false, error: "Error de conexion" } });
    }.bind(this));
  };

  confirmarEnvioRecordatorio = function () {
    var estado = this.state.modalEstadoRecordatorio;
    if (!estado) return;
    var token = this.getToken();
    this.setState({ modalEstadoRecordatorio: null, notificandoRecordatorio: estado.cal.documento });
    axios.post(API_URL + "/admin/notificarrecordatorio/",
      { documento: estado.cal.documento, anio: estado.cal.anio, fechaFin: (estado.cal.fechadefin || '').trim().substring(0, 10) },
      { headers: { Authorization: token } }
    )
    .then(function (r) {
      var data = r.data || {};
      if (data.ok && data.iniciando) {
        data = { ok: true, enviados: data.total, total: data.total, mensaje: null };
      }
      this.setState({ notificandoRecordatorio: null, resultadoRecordatorio: data });
    }.bind(this))
    .catch(function () {
      this.setState({ notificandoRecordatorio: null, resultadoRecordatorio: { ok: false, error: "Error de conexion" } });
    }.bind(this));
  };

  toggleEstadoCalendario = function (cal) {
    var token = this.getToken();
    if (!token) return;
    var nuevoEstado = (cal.estado && cal.estado.trim() === "A") ? "D" : "A";
    this.setState({ cargando: true });
    axios.post(API_URL + "/admin/guardarcalendario/", {
      method: "post", credentials: "same-origin", mode: "cors",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" },
      body: JSON.stringify({
        autorizacion: token,
        anio: cal.anio || this.state.anio,
        documento: cal.documento,
        nombre: cal.documento,
        fechadeinicio: cal.fechadeinicio,
        fechadefin: cal.fechadefin,
        estado: nuevoEstado,
        tituloUno: cal.tituloUno || "",
        tituloDos: cal.tituloDos || "",
        tituloTres: cal.tituloTres || "",
        observacion: cal.observacion || "",
        descripcion: cal.descripcion || ""
      })
    }).then(function () {
      this.setState({ modalExito: nuevoEstado === "A" ? "Declaración jurada ACTIVADA." : "", modalError: nuevoEstado === "D" ? "Declaración jurada DESACTIVADA." : "" });
      this.buscarCalendarios();
    }.bind(this)).catch(function (err) {
      console.error(err);
      this.setState({ modalError: "Error al cambiar estado.", cargando: false });
    }.bind(this));
  };

  eliminarCalendario = function (cal) {
    var token = this.getToken();
    if (!token) return;
    this.setState({ cargando: true, modalConfirmarEliminar: null });
    axios.post(API_URL + "/admin/eliminarcalendario/", {
      method: "post", credentials: "same-origin", mode: "cors",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" },
      body: JSON.stringify({
        autorizacion: token,
        anio: cal.anio || this.state.anio,
        documento: cal.documento
      })
    }).then(function () {
      this.setState({ modalExito: "Declaración jurada eliminada correctamente." });
      this.buscarCalendarios();
    }.bind(this)).catch(function (err) {
      console.error(err);
      this.setState({ modalError: "Error al eliminar la declaración jurada.", cargando: false });
    }.bind(this));
  };

  getColorEstado = function (estado, fechaFin) {
    // Si esta activo pero la fecha de cierre ya paso, mostrarlo como vencido
    if (estado === "A" && fechaFin) {
      var ff = new Date(fechaFin.trim());
      if (ff < new Date()) {
        return { bg: "#fff3e0", color: "#E65100", texto: "Vencido" };
      }
    }
    if (estado === "A") return { bg: "#e8f5e9", color: "#2E7D32", texto: "Activo" };
    if (estado === "D") return { bg: "#fdecea", color: "#C62828", texto: "Desactivo" };
    if (estado === "U") return { bg: "#e3f2fd", color: "#1565C0", texto: "Usado" };
    return { bg: "#f5f5f5", color: "#555", texto: estado };
  };

  render() {
    var datos = this.getDatos();
    if (!datos) return <Redirect to="/" />;
    if (this.state.volverPanel) return <Redirect push={false} to={{ pathname: "/admin-dashboard", state: { datos: datos } }} />;
    if (this.state.irValidar) return <Redirect push={true} to={{ pathname: "/admin-validar-declaraciones", state: { datos: datos, calendario: this.state.irValidar } }} />;

    var anios = this.state.aniosDisponibles;

    var inputStyle = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "0.85rem", background: "#fff", outline: "none" };
    var labelStyle = { fontWeight: "600", fontSize: "0.82rem", color: "#555", marginBottom: "4px", display: "block" };

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>
        <MDBContainer fluid className="pt-4 px-4 pb-4">

          {/* Header */}
          <MDBCard className="mb-3" style={{ borderRadius: "14px", border: "none", boxShadow: "0 2px 12px rgba(106,27,154,0.15)", overflow: "hidden" }}>
            <div style={{ background: "linear-gradient(135deg, #6A1B9A, #8E24AA)", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MDBIcon icon="calendar-alt" style={{ color: "#fff", fontSize: "1.2rem" }} />
                </div>
                <div>
                  <div style={{ color: "#fff", fontWeight: "700", fontSize: "1.05rem" }}>Gestión de Declaraciones Juradas</div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.8rem" }}>Apertura y calendarización de declaraciones</div>
                </div>
              </div>
              <button
                onClick={function () { this.setState({ volverPanel: true }); }.bind(this)}
                style={{ background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: "8px", padding: "8px 18px", cursor: "pointer", fontSize: "0.83rem", fontWeight: "600" }}
              >
                <MDBIcon icon="arrow-left" className="mr-2" />Volver al Panel
              </button>
            </div>
          </MDBCard>

          {/* Filtro + botón nuevo (solo visible cuando NO hay formulario abierto) */}
          {!this.state.mostrarFormulario && (
            <MDBCard className="mb-3" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.07)" }}>
              <MDBCardBody style={{ padding: "16px 24px" }}>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <MDBIcon icon="filter" style={{ color: "#6A1B9A", fontSize: "0.9rem" }} />
                    <span style={{ fontWeight: "600", fontSize: "0.85rem", color: "#555" }}>Año:</span>
                    <select
                      value={this.state.anio}
                      onChange={function (e) { this.setState({ anio: e.target.value }); }.bind(this)}
                      style={{ padding: "7px 14px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "0.85rem", background: "#fff", cursor: "pointer" }}
                    >
                      {anios.map(function (a) { return <option key={a} value={a}>{a}</option>; })}
                    </select>
                  </div>
                  <button
                    onClick={this.buscarCalendarios.bind(this)}
                    disabled={this.state.cargando}
                    style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 20px", cursor: "pointer", fontSize: "0.83rem", fontWeight: "600" }}
                  >
                    <MDBIcon icon={this.state.cargando ? "spinner" : "search"} className="mr-2" spin={this.state.cargando} />
                    {this.state.cargando ? "Buscando..." : "Buscar"}
                  </button>
                  <div style={{ marginLeft: "auto" }}>
                    <button
                      onClick={function () { this.limpiarFormulario(); this.setState({ mostrarFormulario: true, editando: false }); }.bind(this)}
                      style={{ background: "#6A1B9A", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 20px", cursor: "pointer", fontSize: "0.83rem", fontWeight: "600" }}
                    >
                      <MDBIcon icon="plus" className="mr-2" />Nueva Declaración Jurada
                    </button>
                  </div>
                </div>
              </MDBCardBody>
            </MDBCard>
          )}

          {/* Formulario */}
          {this.state.mostrarFormulario && (
            <div>
              {/* RECUADRO 1: Datos principales */}
              <MDBCard className="mb-3" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 12px rgba(245,124,0,0.18)", overflow: "hidden" }}>
                <div style={{ background: "linear-gradient(135deg, #F57C00, #FB8C00)", padding: "14px 24px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <MDBIcon icon={this.state.editando ? "edit" : "plus-circle"} style={{ color: "#fff", fontSize: "1rem" }} />
                  <span style={{ color: "#fff", fontWeight: "700", fontSize: "0.95rem" }}>
                    {this.state.editando ? "Editar Declaración Jurada: " + this.state.documento : "Nueva Declaración Jurada"}
                  </span>
                  <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: "20px", padding: "2px 12px", fontSize: "0.75rem" }}>
                    Datos Generales
                  </span>
                </div>
                <MDBCardBody style={{ padding: "20px 24px" }}>
                  <MDBRow>
                    <MDBCol md="4">
                      <div className="mb-3">
                        <label style={labelStyle}>Tipo de Declaración Jurada <span style={{ color: "#e53935" }}>*</span></label>
                        <select value={this.state.documento}
                          onChange={function (e) { this.setState({ documento: e.target.value }); }.bind(this)}
                          disabled={this.state.editando}
                          style={Object.assign({}, inputStyle, { background: this.state.editando ? "#f5f5f5" : "#fff", color: this.state.editando ? "#888" : "#333" })}
                        >
                          <option value="">-- Seleccione --</option>
                          <option value="AGUINALDO-JULIO">AGUINALDO-JULIO</option>
                          <option value="AGUINALDO-DICIEMBRE">AGUINALDO-DICIEMBRE</option>
                          <option value="ESCOLARIDAD">ESCOLARIDAD</option>
                        </select>
                      </div>
                    </MDBCol>
                    <MDBCol md="2">
                      <div className="mb-3">
                        <label style={labelStyle}>Año <span style={{ color: "#e53935" }}>*</span></label>
                        <input type="number" value={this.state.anioFormulario}
                          onChange={function (e) { this.setState({ anioFormulario: e.target.value }); }.bind(this)}
                          min="2020" max="2099" style={inputStyle}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol md="3">
                      <div className="mb-3">
                        <label style={labelStyle}>Fecha Inicio <span style={{ color: "#e53935" }}>*</span></label>
                        <input type="date" value={this.state.fechaInicio}
                          onChange={function (e) {
                            var fi = e.target.value;
                            var ff = "";
                            if (fi) {
                              var p = fi.split('-');
                              var d = new Date(parseInt(p[0]), parseInt(p[1]) - 1, parseInt(p[2]) + 7);
                              ff = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
                            }
                            this.setState({ fechaInicio: fi, fechaFin: ff });
                          }.bind(this)}
                          style={inputStyle}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol md="3">
                      <div className="mb-3">
                        <label style={labelStyle}>Fecha Fin <span style={{ color: "#e53935" }}>*</span></label>
                        <input type="date" value={this.state.fechaFin}
                          onChange={function (e) { this.setState({ fechaFin: e.target.value }); }.bind(this)}
                          style={inputStyle}
                        />
                        {this.state.fechaFin && this.state.fechaInicio && new Date(this.state.fechaFin) <= new Date(this.state.fechaInicio) && (
                          <span style={{ color: "#e53935", fontSize: "0.75rem" }}>
                            <MDBIcon icon="exclamation-circle" className="mr-1" />La fecha fin debe ser posterior a la fecha inicio
                          </span>
                        )}
                      </div>
                    </MDBCol>

                    {/* Selector de modo de asignación */}
                    <MDBCol md="12">
                      <div className="mb-3">
                        <label style={labelStyle}>Modo de asignación <span style={{ color: "#e53935" }}>*</span></label>
                        <div style={{ display: "flex", gap: "12px" }}>
                          {/* Opción: Por Planilla */}
                          <div
                            onClick={function () {
                              this.setState({ modoAsignacion: "PLANILLA" });
                            }.bind(this)}
                            style={{
                              flex: 1, borderRadius: "12px", padding: "14px 18px", cursor: "pointer",
                              border: "2px solid " + (this.state.modoAsignacion === "PLANILLA" ? "#6A1B9A" : "#ddd"),
                              background: this.state.modoAsignacion === "PLANILLA" ? "linear-gradient(135deg, #F3E5F5, #EDE7F6)" : "#fafafa",
                              boxShadow: this.state.modoAsignacion === "PLANILLA" ? "0 2px 10px rgba(106,27,154,0.2)" : "none",
                              transition: "all 0.2s"
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                              <div style={{
                                width: "36px", height: "36px", borderRadius: "8px", flexShrink: 0,
                                background: this.state.modoAsignacion === "PLANILLA" ? "#6A1B9A" : "#e0e0e0",
                                display: "flex", alignItems: "center", justifyContent: "center"
                              }}>
                                <MDBIcon icon="layer-group" style={{ color: "#fff", fontSize: "1rem" }} />
                              </div>
                              <div>
                                <div style={{ fontWeight: "700", fontSize: "0.88rem", color: this.state.modoAsignacion === "PLANILLA" ? "#6A1B9A" : "#555" }}>
                                  Por Tipo de Planilla
                                </div>
                                <div style={{ fontSize: "0.74rem", color: "#888" }}>DOA · DOC</div>
                              </div>
                              {this.state.modoAsignacion === "PLANILLA" && (
                                <MDBIcon icon="check-circle" style={{ color: "#6A1B9A", marginLeft: "auto", fontSize: "1.1rem" }} />
                              )}
                            </div>
                            <div style={{ fontSize: "0.75rem", color: "#888", lineHeight: "1.4" }}>
                              Aplica a todos los trabajadores activos del tipo seleccionado.
                            </div>
                          </div>

                          {/* Opción: Por Trabajador Individual */}
                          <div
                            onClick={function () {
                              this.setState({ modoAsignacion: "TRABAJADOR" });
                            }.bind(this)}
                            style={{
                              flex: 1, borderRadius: "12px", padding: "14px 18px", cursor: "pointer",
                              border: "2px solid " + (this.state.modoAsignacion === "TRABAJADOR" ? "#1565C0" : "#ddd"),
                              background: this.state.modoAsignacion === "TRABAJADOR" ? "linear-gradient(135deg, #E3F2FD, #BBDEFB22)" : "#fafafa",
                              boxShadow: this.state.modoAsignacion === "TRABAJADOR" ? "0 2px 10px rgba(21,101,192,0.2)" : "none",
                              transition: "all 0.2s"
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                              <div style={{
                                width: "36px", height: "36px", borderRadius: "8px", flexShrink: 0,
                                background: this.state.modoAsignacion === "TRABAJADOR" ? "#1565C0" : "#e0e0e0",
                                display: "flex", alignItems: "center", justifyContent: "center"
                              }}>
                                <MDBIcon icon="user-check" style={{ color: "#fff", fontSize: "1rem" }} />
                              </div>
                              <div>
                                <div style={{ fontWeight: "700", fontSize: "0.88rem", color: this.state.modoAsignacion === "TRABAJADOR" ? "#1565C0" : "#555" }}>
                                  Por Trabajador Individual
                                </div>
                                <div style={{ fontSize: "0.74rem", color: "#888" }}>Selección uno a uno por DNI o nombre</div>
                              </div>
                              {this.state.modoAsignacion === "TRABAJADOR" && (
                                <MDBIcon icon="check-circle" style={{ color: "#1565C0", marginLeft: "auto", fontSize: "1.1rem" }} />
                              )}
                            </div>
                            <div style={{ fontSize: "0.75rem", color: "#888", lineHeight: "1.4" }}>
                              Aplica únicamente a los trabajadores que selecciones de forma individual.
                            </div>
                          </div>
                        </div>
                      </div>
                    </MDBCol>

                    {/* Contenido: ambas secciones siempre visibles */}
                    <MDBCol md="12">
                        <div className="mb-3">
                          <label style={labelStyle}>Seleccione los tipos de planilla <span style={{ color: "#e53935" }}>*</span></label>
                          <div style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px 14px", background: "#fafafa", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {this.state.tiposPlanilla.length === 0 && (
                              <span style={{ fontSize: "0.8rem", color: "#aaa" }}>Cargando planillas...</span>
                            )}
                            {this.state.tiposPlanilla.filter(function (p) { var c = p.tipoplanilla ? p.tipoplanilla.trim() : ""; return ["DOA","DOC"].indexOf(c) >= 0; }).map(function (p) {
                              var codigo = p.tipoplanilla ? p.tipoplanilla.trim() : "";
                              var checked = this.state.planillasSeleccionadas.indexOf(codigo) >= 0;
                              return (
                                <div key={codigo} onClick={function () { this.togglePlanilla(codigo); }.bind(this)} style={{
                                  display: "flex", alignItems: "center", gap: "8px",
                                  padding: "8px 14px", borderRadius: "10px", cursor: "pointer",
                                  border: "2px solid " + (checked ? "#6A1B9A" : "#ddd"),
                                  background: checked ? "#EDE7F6" : "#fff",
                                  transition: "all 0.15s",
                                  userSelect: "none"
                                }}>
                                  <div style={{
                                    width: "18px", height: "18px", borderRadius: "4px", flexShrink: 0,
                                    background: checked ? "#6A1B9A" : "#f0f0f0",
                                    border: "2px solid " + (checked ? "#6A1B9A" : "#ccc"),
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                  }}>
                                    {checked && <MDBIcon icon="check" style={{ color: "#fff", fontSize: "0.6rem" }} />}
                                  </div>
                                  <span style={{ fontWeight: "700", fontSize: "0.85rem", color: checked ? "#6A1B9A" : "#555" }}>{codigo}</span>
                                </div>
                              );
                            }.bind(this))}
                          </div>
                          {this.state.planillasSeleccionadas.length > 0 && (
                            <div style={{ marginTop: "10px" }}>
                              {this.state.cargandoTrabajadores ? (
                                <div style={{ fontSize: "0.78rem", color: "#888" }}>
                                  <MDBIcon icon="spinner" spin className="mr-1" />Consultando trabajadores activos...
                                </div>
                              ) : (
                                <div style={{ background: "linear-gradient(135deg, #EDE7F6, #F3E5F5)", border: "1px solid #CE93D8", borderRadius: "8px", padding: "10px 14px", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                                  <MDBIcon icon="users" style={{ color: "#6A1B9A", fontSize: "1rem" }} />
                                  <span style={{ fontSize: "1.3rem", fontWeight: "800", color: "#6A1B9A", lineHeight: 1 }}>{this.state.totalTrabajadores}</span>
                                  <span style={{ fontSize: "0.8rem", color: "#7B1FA2", fontWeight: "600" }}>trabajadores activos incluidos en la declaración</span>
                                  <div style={{ display: "flex", gap: "4px", flexWrap: "wrap", marginLeft: "4px" }}>
                                    {this.state.planillasSeleccionadas.map(function(p){
                                      return <span key={p} style={{ background: "#6A1B9A", color: "#fff", borderRadius: "10px", padding: "2px 8px", fontSize: "0.72rem", fontWeight: "700" }}>{p}</span>;
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </MDBCol>

                    <MDBCol md="12">
                        <div className="mb-3">
                          <label style={labelStyle}>
                            Buscar y agregar trabajadores <span style={{ color: "#e53935" }}>*</span>
                            {this.state.trabajadoresSeleccionados.length > 0 && (
                              <span style={{ marginLeft: "8px", background: "#1565C0", color: "#fff", borderRadius: "10px", padding: "1px 9px", fontSize: "0.72rem", fontWeight: "700" }}>
                                {this.state.trabajadoresSeleccionados.length} seleccionado{this.state.trabajadoresSeleccionados.length !== 1 ? "s" : ""}
                              </span>
                            )}
                          </label>
                          <div style={{ position: "relative", marginBottom: "10px" }}>
                            <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "8px", background: "#fff", padding: "8px 12px", gap: "8px" }}>
                              <MDBIcon icon={this.state.cargandoBusqueda ? "spinner" : "search"} spin={this.state.cargandoBusqueda} style={{ color: "#aaa", fontSize: "0.9rem", flexShrink: 0 }} />
                              <input
                                type="text"
                                value={this.state.busquedaTrabajador}
                                onChange={function (e) { this.onBusquedaChange(e.target.value); }.bind(this)}
                                onFocus={function () { this.setState({ mostrarSugerencias: true }); }.bind(this)}
                                onBlur={function () { setTimeout(function () { this.setState({ mostrarSugerencias: false }); }.bind(this), 200); }.bind(this)}
                                placeholder="Buscar por DNI, código o nombre completo..."
                                style={{ border: "none", outline: "none", fontSize: "0.85rem", flex: 1, minWidth: 0 }}
                              />
                            </div>
                            {this.state.mostrarSugerencias && this.state.sugerencias.length > 0 && (
                              <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #ddd", borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 100, maxHeight: "220px", overflowY: "auto" }}>
                                {this.state.sugerencias.map(function (s, i) {
                                  var yaAgregado = this.state.trabajadoresSeleccionados.find(function (t) { return t.CodigoTrabajador === s.CodigoTrabajador; });
                                  return (
                                    <div key={i}
                                      onMouseDown={function () { if (!yaAgregado) this.seleccionarSugerencia(s); }.bind(this)}
                                      style={{ padding: "10px 14px", cursor: yaAgregado ? "default" : "pointer", background: yaAgregado ? "#f5f5f5" : "#fff", borderBottom: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                    >
                                      <div>
                                        <div style={{ fontSize: "0.84rem", fontWeight: "600", color: yaAgregado ? "#aaa" : "#333" }}>{s.NombreCompleto}</div>
                                        <div style={{ fontSize: "0.74rem", color: "#888" }}>DNI: {s.DNI} &nbsp;·&nbsp; Cód: {s.CodigoTrabajador}</div>
                                      </div>
                                      {yaAgregado
                                        ? <span style={{ background: "#e8f5e9", color: "#2E7D32", borderRadius: "8px", padding: "3px 8px", fontSize: "0.72rem", fontWeight: "700" }}><MDBIcon icon="check" className="mr-1" />Agregado</span>
                                        : <span style={{ background: "#e3f2fd", color: "#1565C0", borderRadius: "8px", padding: "3px 8px", fontSize: "0.72rem", fontWeight: "700" }}><MDBIcon icon="plus" className="mr-1" />Agregar</span>
                                      }
                                    </div>
                                  );
                                }.bind(this))}
                              </div>
                            )}
                          </div>
                          {this.state.trabajadoresSeleccionados.length > 0 ? (
                            <div style={{ border: "1px solid #90CAF9", borderRadius: "8px", padding: "10px 12px", background: "#f8fbff", display: "flex", flexWrap: "wrap", gap: "6px", maxHeight: "130px", overflowY: "auto" }}>
                              {this.state.trabajadoresSeleccionados.map(function (t) {
                                return (
                                  <span key={t.CodigoTrabajador} style={{ display: "inline-flex", alignItems: "center", gap: "5px", background: "#E3F2FD", color: "#1565C0", border: "1px solid #90CAF9", borderRadius: "20px", padding: "4px 12px", fontSize: "0.78rem", fontWeight: "600" }}>
                                    <MDBIcon icon="user" style={{ fontSize: "0.7rem" }} />
                                    {t.NombreCompleto}
                                    <span onMouseDown={function () { this.quitarTrabajador(t.CodigoTrabajador); }.bind(this)}
                                      style={{ cursor: "pointer", marginLeft: "3px", color: "#1565C0", fontWeight: "800", fontSize: "0.9rem", lineHeight: 1, opacity: 0.7 }}>×</span>
                                  </span>
                                );
                              }.bind(this))}
                            </div>
                          ) : (
                            <div style={{ border: "1px dashed #ccc", borderRadius: "8px", padding: "20px", textAlign: "center", color: "#bbb", fontSize: "0.82rem" }}>
                              <MDBIcon icon="user-plus" style={{ fontSize: "1.5rem", display: "block", marginBottom: "6px" }} />
                              Aún no se ha agregado ningún trabajador
                            </div>
                          )}
                        </div>
                      </MDBCol>
                  </MDBRow>

                  {/* Notificación por correo */}
                  {(function() {
                    var todosActualesUI = (this.state.trabajadoresPlanilla || []).concat(this.state.trabajadoresSeleccionados || []).filter(function(t, i, arr) {
                      return arr.findIndex(function(x){ return x.CodigoTrabajador === t.CodigoTrabajador; }) === i;
                    });
                    var yaNotifUI = this.state.trabajadoresYaNotificados || [];
                    var nuevosUI = todosActualesUI.filter(function(t){ return yaNotifUI.indexOf(t.CodigoTrabajador) === -1; });
                    var yaNotifCount = todosActualesUI.length - nuevosUI.length;

                    return (
                      <MDBRow>
                        <MDBCol md="12">
                          <div className="mb-3" style={{ borderRadius: "10px", padding: "14px 18px", border: "1px solid #bbdefb", background: "#f0f7ff" }}>
                            <div style={{ fontWeight: "700", fontSize: "0.82rem", color: "#1565C0", marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
                              <MDBIcon icon="envelope" /> Notificación por correo
                            </div>

                            {/* MODO CREACIÓN */}
                            {!this.state.editando && (
                              <div>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
                                  <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", margin: 0 }}>
                                    <input
                                      type="checkbox"
                                      checked={this.state.notificarCorreo}
                                      onChange={function(e){ this.setState({ notificarCorreo: e.target.checked, enviarPrueba: false, resultadoPrueba: null }); }.bind(this)}
                                      style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                    />
                                    <span style={{ fontWeight: "600", fontSize: "0.85rem", color: "#1A237E" }}>
                                      Notificar a todos los trabajadores que se habilitó la declaración
                                    </span>
                                  </label>
                                  {this.state.notificarCorreo && this.state.totalTrabajadores > 0 && (
                                    <span style={{ background: "#1565C0", color: "#fff", borderRadius: "10px", padding: "2px 10px", fontSize: "0.74rem", fontWeight: "600" }}>
                                      {this.state.totalTrabajadores} trabajador(es)
                                    </span>
                                  )}
                                </div>

                                {this.state.notificarCorreo && (
                                  <div>
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", margin: "0 0 10px 0" }}>
                                      <input
                                        type="checkbox"
                                        checked={this.state.enviarPrueba}
                                        onChange={function(e){ this.setState({ enviarPrueba: e.target.checked, resultadoPrueba: null }); }.bind(this)}
                                        style={{ width: "15px", height: "15px", cursor: "pointer" }}
                                      />
                                      <span style={{ fontSize: "0.82rem", color: "#555" }}>Enviar correo de prueba antes de guardar</span>
                                    </label>
                                    {this.state.enviarPrueba && (
                                      <div style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "4px" }}>
                                        <input
                                          type="email"
                                          value={this.state.correoPrueba}
                                          onChange={function(e){ this.setState({ correoPrueba: e.target.value, resultadoPrueba: null }); }.bind(this)}
                                          placeholder="correo@unsaac.edu.pe"
                                          style={{ width: "280px", padding: "7px 12px", borderRadius: "8px", border: "1px solid #90CAF9", fontSize: "0.83rem", outline: "none" }}
                                        />
                                        <button
                                          onClick={this.enviarCorreoPrueba.bind(this)}
                                          disabled={this.state.enviandoPrueba || !this.state.correoPrueba.trim()}
                                          style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", cursor: "pointer", fontSize: "0.82rem", fontWeight: "600", opacity: (this.state.enviandoPrueba || !this.state.correoPrueba.trim()) ? 0.6 : 1, whiteSpace: "nowrap" }}
                                        >
                                          {this.state.enviandoPrueba
                                            ? <span><MDBIcon icon="spinner" spin className="mr-1" />Enviando...</span>
                                            : <span><MDBIcon icon="paper-plane" className="mr-1" />Enviar prueba</span>
                                          }
                                        </button>
                                      </div>
                                    )}
                                    {this.state.resultadoPrueba && (
                                      <div style={{ marginTop: "8px", padding: "8px 12px", borderRadius: "8px", fontSize: "0.8rem", fontWeight: "600", background: this.state.resultadoPrueba.ok ? "#e8f5e9" : "#fdecea", color: this.state.resultadoPrueba.ok ? "#2E7D32" : "#C62828", border: "1px solid " + (this.state.resultadoPrueba.ok ? "#a5d6a7" : "#ef9a9a") }}>
                                        <MDBIcon icon={this.state.resultadoPrueba.ok ? "check-circle" : "exclamation-circle"} className="mr-1" />
                                        {this.state.resultadoPrueba.ok ? "Correo de prueba enviado a " + this.state.correoPrueba : "Error: " + this.state.resultadoPrueba.error}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}

                            {/* MODO EDICIÓN */}
                            {this.state.editando && (
                              <div>
                                {this.state.cargandoNotificados ? (
                                  <div style={{ color: "#888", fontSize: "0.83rem" }}>
                                    <MDBIcon icon="spinner" spin className="mr-1" /> Cargando información de notificaciones...
                                  </div>
                                ) : nuevosUI.length === 0 ? (
                                  <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "10px 14px", color: "#2E7D32", fontSize: "0.83rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px" }}>
                                    <MDBIcon icon="check-circle" />
                                    Todos los {todosActualesUI.length} trabajadores ya fueron notificados anteriormente. No hay nuevos a notificar.
                                  </div>
                                ) : (
                                  <div>
                                    {yaNotifCount > 0 && (
                                      <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "8px 12px", color: "#2E7D32", fontSize: "0.78rem", marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px" }}>
                                        <MDBIcon icon="check-circle" />
                                        {yaNotifCount} trabajador(es) ya fueron notificados anteriormente y no recibirán correo nuevamente.
                                      </div>
                                    )}
                                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
                                      <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", margin: 0 }}>
                                        <input
                                          type="checkbox"
                                          checked={this.state.notificarCorreo}
                                          onChange={function(e){ this.setState({ notificarCorreo: e.target.checked }); }.bind(this)}
                                          style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                        />
                                        <span style={{ fontWeight: "600", fontSize: "0.85rem", color: "#E65100" }}>
                                          Notificar a {nuevosUI.length} trabajador(es) nuevo(s) que no fueron notificados anteriormente
                                        </span>
                                      </label>
                                    </div>
                                    {this.state.notificarCorreo && (
                                      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
                                        {nuevosUI.map(function(t) {
                                          return (
                                            <span key={t.CodigoTrabajador} style={{ background: "#FFF3E0", color: "#E65100", border: "1px solid #FFCC80", borderRadius: "20px", padding: "3px 10px", fontSize: "0.76rem", fontWeight: "600" }}>
                                              <MDBIcon icon="user" style={{ fontSize: "0.68rem", marginRight: "4px" }} />
                                              {t.NombreCompleto || t.NOMBRES || ("Cód. " + t.CodigoTrabajador)}
                                            </span>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}

                          </div>
                        </MDBCol>
                      </MDBRow>
                    );
                  }).call(this)}

                  {/* Botones */}
                  <div style={{ borderTop: "1px solid #eee", paddingTop: "16px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button onClick={this.limpiarFormulario.bind(this)}
                      style={{ background: "#C62828", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 24px", cursor: "pointer", fontSize: "0.85rem", fontWeight: "600" }}>
                      <MDBIcon icon="times" className="mr-2" />Cancelar
                    </button>
                    <button
                      onClick={function () { this.setState({ modalConfirmarGuardar: true }); }.bind(this)}
                      disabled={this.state.cargando}
                      style={{ background: "#2E7D32", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 28px", cursor: "pointer", fontSize: "0.85rem", fontWeight: "600" }}>
                      <MDBIcon icon="save" className="mr-2" />{this.state.cargando ? "Guardando..." : "Guardar"}
                    </button>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </div>
          )}

          {/* Tabla de calendarios (oculta cuando el formulario está abierto) */}
          {!this.state.mostrarFormulario && (
          <MDBCard style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <div style={{ background: "linear-gradient(135deg, #37474f, #546e7a)", padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <MDBIcon icon="list-alt" style={{ color: "#fff", fontSize: "1rem" }} />
                <span style={{ color: "#fff", fontWeight: "700", fontSize: "0.95rem" }}>
                  Declaraciones Juradas {this.state.anio}
                </span>
                <span style={{ background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: "12px", padding: "2px 10px", fontSize: "0.78rem", fontWeight: "600" }}>
                  {this.state.calendarios.length} registros
                </span>
                {this.state.calendarios.length > 0 && (
                  <span style={{ background: "#2E7D32", color: "#fff", borderRadius: "12px", padding: "2px 10px", fontSize: "0.75rem", fontWeight: "600" }}>
                    {this.state.calendarios.filter(function(c){ return c.estado && c.estado.trim() === "A"; }).length} activas
                  </span>
                )}
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              {this.state.cargando && this.state.calendarios.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <MDBIcon icon="spinner" spin size="2x" style={{ color: "#6A1B9A" }} />
                  <p style={{ color: "#999", marginTop: "10px", fontSize: "0.9rem" }}>Cargando declaraciones juradas...</p>
                </div>
              ) : this.state.calendarios.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <MDBIcon icon="calendar-times" size="2x" style={{ color: "#ccc" }} />
                  <p style={{ color: "#aaa", marginTop: "10px", fontSize: "0.9rem" }}>No se encontraron declaraciones juradas para el año {this.state.anio}</p>
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.83rem" }}>
                  <thead>
                    <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #e9ecef" }}>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Código / Nombre</th>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Fecha Apertura</th>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Fecha Cierre</th>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", textAlign: "center" }}>Estado</th>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555" }}>Tipos de Planilla</th>
                      <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", textAlign: "center" }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.calendarios.map(function (cal, i) {
                      var est = this.getColorEstado(cal.estado ? cal.estado.trim() : "", cal.fechadefin);
                      var esSeleccionado = this.state.editando && this.state.documento === cal.documento;
                      var planillas = cal.observacion ? cal.observacion.split(",").filter(function (p) { return p.trim() !== ""; }) : [];
                      return (
                        <tr key={i} style={{
                          borderBottom: "1px solid #f0f0f0",
                          background: esSeleccionado ? "#fff8e1" : (i % 2 === 0 ? "#fff" : "#fafafa"),
                          transition: "background 0.15s"
                        }}>
                          <td style={{ padding: "11px 16px", fontWeight: "700", color: "#333", whiteSpace: "nowrap" }}>
                            <MDBIcon icon="tag" className="mr-1" style={{ color: "#6A1B9A", fontSize: "0.75rem" }} />
                            {cal.documento}
                          </td>
                          <td style={{ padding: "11px 16px", color: "#555", whiteSpace: "nowrap", fontSize: "0.8rem" }}>
                            <MDBIcon icon="calendar-check" className="mr-1" style={{ color: "#2E7D32" }} />
                            {cal.fechadeinicio ? cal.fechadeinicio.trim().substring(0, 10) : "—"}
                          </td>
                          <td style={{ padding: "11px 16px", color: "#555", whiteSpace: "nowrap", fontSize: "0.8rem" }}>
                            <MDBIcon icon="calendar-times" className="mr-1" style={{ color: "#C62828" }} />
                            {cal.fechadefin ? cal.fechadefin.trim().substring(0, 10) : "—"}
                          </td>
                          <td style={{ padding: "11px 16px", textAlign: "center" }}>
                            <span style={{ background: est.bg, color: est.color, padding: "4px 14px", borderRadius: "20px", fontSize: "0.76rem", fontWeight: "700" }}>
                              {est.texto}
                            </span>
                          </td>
                          <td style={{ padding: "11px 16px", fontSize: "0.78rem" }}>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                              {planillas.map(function (p, idx) {
                                return (
                                  <span key={idx} style={{ background: "#EDE7F6", color: "#6A1B9A", padding: "3px 8px", borderRadius: "12px", fontSize: "0.75rem", fontWeight: "700", border: "1px solid #CE93D8" }}>
                                    {p.trim()}
                                  </span>
                                );
                              })}
                              {cal.totalIndividuales > 0 && (
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", background: "#E3F2FD", color: "#1565C0", padding: "3px 10px", borderRadius: "12px", fontSize: "0.75rem", fontWeight: "600", border: "1px solid #90CAF9" }}>
                                  <MDBIcon icon="user-check" style={{ fontSize: "0.7rem" }} />
                                  {cal.totalIndividuales} individual{cal.totalIndividuales !== 1 ? "es" : ""}
                                </span>
                              )}
                              {planillas.length === 0 && !(cal.totalIndividuales > 0) && (
                                <span style={{ color: "#ccc" }}>—</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: "11px 16px", textAlign: "center", whiteSpace: "nowrap", verticalAlign: "middle" }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                            <div
                              onClick={function () { this.toggleEstadoCalendario(cal); }.bind(this)}
                              title={cal.estado && cal.estado.trim() === "A" ? "Desactivar" : "Activar"}
                              style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", minWidth: "110px" }}
                            >
                              <div style={{
                                width: "36px", height: "20px", borderRadius: "10px", flexShrink: 0,
                                background: cal.estado && cal.estado.trim() === "A" ? "#2E7D32" : "#C62828",
                                position: "relative", transition: "background 0.2s"
                              }}>
                                <div style={{
                                  width: "16px", height: "16px", borderRadius: "50%", background: "#fff",
                                  position: "absolute", top: "2px",
                                  left: cal.estado && cal.estado.trim() === "A" ? "18px" : "2px",
                                  transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.3)"
                                }}></div>
                              </div>
                              <span style={{ fontSize: "0.72rem", fontWeight: "600", color: cal.estado && cal.estado.trim() === "A" ? "#2E7D32" : "#C62828" }}>
                                {cal.estado && cal.estado.trim() === "A" ? "Activado" : "Desactivado"}
                              </span>
                            </div>
                            <button
                              onClick={function () { this.seleccionarCalendario(cal); }.bind(this)}
                              style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "7px", padding: "6px 12px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600", marginLeft: "6px" }}
                            >
                              <MDBIcon icon="edit" className="mr-1" />Editar
                            </button>
                            <button
                              onClick={function () { this.setState({ irValidar: cal }); }.bind(this)}
                              style={{ background: "#6A1B9A", color: "#fff", border: "none", borderRadius: "7px", padding: "6px 12px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600", marginLeft: "6px" }}
                            >
                              <MDBIcon icon="folder-open" className="mr-1" />Revisar Archivos
                            </button>
                            <button
                              onClick={function () { this.setState({ modalConfirmarEliminar: cal }); }.bind(this)}
                              style={{ background: "#b71c1c", color: "#fff", border: "none", borderRadius: "7px", padding: "6px 12px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600", marginLeft: "6px" }}
                            >
                              <MDBIcon icon="trash" className="mr-1" />Eliminar
                            </button>
                            </div>
                          </td>
                        </tr>
                      );
                    }.bind(this))}
                  </tbody>
                </table>
              )}
            </div>
          </MDBCard>
          )}

        </MDBContainer>

        {/* Modal Éxito */}
        {this.state.modalExito && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#e8f5e9", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="check-circle" style={{ color: "#2E7D32", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1.05rem", fontWeight: "700", color: "#2E7D32", marginBottom: "20px" }}>{this.state.modalExito}</p>
              <button onClick={function () { this.setState({ modalExito: "" }); }.bind(this)}
                style={{ background: "#2E7D32", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Aceptar
              </button>
            </div>
          </div>
        )}

        {/* Modal Confirmar Eliminar */}
        {this.state.modalConfirmarEliminar && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "16px", padding: "0", maxWidth: "460px", width: "90%", boxShadow: "0 10px 40px rgba(0,0,0,0.3)", overflow: "hidden" }}>
              {/* Cabecera roja */}
              <div style={{ background: "linear-gradient(135deg, #b71c1c, #C62828)", padding: "20px 24px", display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <MDBIcon icon="trash-alt" style={{ color: "#fff", fontSize: "1.3rem" }} />
                </div>
                <div>
                  <div style={{ color: "#fff", fontWeight: "800", fontSize: "1rem" }}>Eliminar declaración jurada</div>
                  <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.82rem", marginTop: "2px" }}>{this.state.modalConfirmarEliminar.documento} — {this.state.modalConfirmarEliminar.anio}</div>
                </div>
              </div>
              {/* Cuerpo */}
              <div style={{ padding: "20px 24px" }}>
                <p style={{ fontSize: "0.88rem", color: "#333", fontWeight: "600", marginBottom: "12px" }}>
                  Esta acción es <span style={{ color: "#C62828" }}>irreversible</span>. Se eliminará permanentemente:
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
                  {[
                    { icon: "calendar-times", text: "La declaración jurada y sus fechas de vigencia" },
                    { icon: "layer-group",    text: "Los tipos de planilla asignados (DOA, DOC, etc.)" },
                    { icon: "users",          text: "Los trabajadores individuales asignados" },
                    { icon: "file-pdf",       text: "El registro de seguimiento de firmas" }
                  ].map(function(item, i) {
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: "10px", background: "#fff5f5", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "8px 12px" }}>
                        <MDBIcon icon={item.icon} style={{ color: "#C62828", fontSize: "0.9rem", width: "16px", flexShrink: 0 }} />
                        <span style={{ fontSize: "0.82rem", color: "#555" }}>{item.text}</span>
                      </div>
                    );
                  })}
                </div>
                <p style={{ fontSize: "0.8rem", color: "#888", marginBottom: "0", fontStyle: "italic" }}>
                  Los archivos PDF ya subidos por los trabajadores no se eliminan del servidor.
                </p>
              </div>
              {/* Botones */}
              <div style={{ padding: "0 24px 20px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <button onClick={function () { this.setState({ modalConfirmarEliminar: null }); }.bind(this)}
                  style={{ background: "#fff", color: "#555", border: "1px solid #ccc", borderRadius: "8px", padding: "9px 24px", cursor: "pointer", fontSize: "0.88rem", fontWeight: "600" }}>
                  Cancelar
                </button>
                <button onClick={function () { this.eliminarCalendario(this.state.modalConfirmarEliminar); }.bind(this)}
                  style={{ background: "linear-gradient(135deg, #b71c1c, #C62828)", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 24px", cursor: "pointer", fontSize: "0.88rem", fontWeight: "700", display: "flex", alignItems: "center", gap: "6px" }}>
                  <MDBIcon icon="trash-alt" />Sí, eliminar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Confirmar Guardar */}
        {this.state.modalConfirmarGuardar && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 36px", maxWidth: "460px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#e3f2fd", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="question-circle" style={{ color: "#1565C0", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1.05rem", fontWeight: "700", color: "#333", marginBottom: "10px" }}>
                {this.state.editando ? "¿Confirmar actualización de declaración jurada?" : "¿Confirmar apertura de declaración jurada?"}
              </p>
              {this.state.notificarCorreo ? (
                <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "8px", padding: "12px 16px", marginBottom: "20px", fontSize: "0.87rem", color: "#2E7D32" }}>
                  <MDBIcon icon="envelope" className="mr-2" />
                  {this.state.editando
                    ? "Se enviará un recordatorio a los trabajadores que aún no han firmado."
                    : <>Se enviará notificación por correo a <strong>{this.state.totalTrabajadores > 0 ? this.state.totalTrabajadores + " trabajadores" : "los trabajadores asignados"}</strong> al guardar.</>
                  }
                </div>
              ) : (
                <div style={{ background: "#fff8e1", border: "1px solid #ffe082", borderRadius: "8px", padding: "12px 16px", marginBottom: "20px", fontSize: "0.87rem", color: "#E65100" }}>
                  <MDBIcon icon="exclamation-triangle" className="mr-2" />
                  {this.state.editando
                    ? "Se guardarán los cambios sin enviar recordatorio a los trabajadores."
                    : "La declaración se abrirá sin enviar notificaciones por correo. Los trabajadores no serán avisados automáticamente."
                  }
                </div>
              )}
              <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                <button
                  onClick={function () { this.setState({ modalConfirmarGuardar: false }); }.bind(this)}
                  style={{ background: "#fff", color: "#666", border: "1px solid #ccc", borderRadius: "8px", padding: "10px 30px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  Cancelar
                </button>
                <button
                  onClick={function () { this.setState({ modalConfirmarGuardar: false }, function () { this.guardarCalendario(); }.bind(this)); }.bind(this)}
                  style={{ background: "#2E7D32", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 30px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  <MDBIcon icon="save" className="mr-2" />Confirmar y Guardar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Estado + Confirmación Recordatorio */}
        {this.state.modalEstadoRecordatorio && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 36px", maxWidth: "460px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fff3e0", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="bell" style={{ color: "#E65100", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1rem", fontWeight: "700", color: "#333", marginBottom: "18px" }}>
                Estado de firmas — {this.state.modalEstadoRecordatorio.cal && this.state.modalEstadoRecordatorio.cal.documento}
              </p>

              {/* Tarjetas de estado */}
              <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginBottom: "20px" }}>
                <div style={{ flex: 1, background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#2E7D32", lineHeight: 1 }}>
                    {this.state.modalEstadoRecordatorio.firmaron}
                  </div>
                  <div style={{ fontSize: "0.78rem", color: "#2E7D32", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="check-circle" className="mr-1" />Firmaron
                  </div>
                </div>
                <div style={{ flex: 1, background: "#fff3e0", border: "1px solid #ffcc80", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#E65100", lineHeight: 1 }}>
                    {this.state.modalEstadoRecordatorio.pendientes}
                  </div>
                  <div style={{ fontSize: "0.78rem", color: "#E65100", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="clock" className="mr-1" />Pendientes
                  </div>
                </div>
                <div style={{ flex: 1, background: "#f5f5f5", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#555", lineHeight: 1 }}>
                    {this.state.modalEstadoRecordatorio.total}
                  </div>
                  <div style={{ fontSize: "0.78rem", color: "#555", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="users" className="mr-1" />Total
                  </div>
                </div>
              </div>

              {this.state.modalEstadoRecordatorio.pendientes === 0 ? (
                <p style={{ fontSize: "0.9rem", color: "#2E7D32", fontWeight: "600", marginBottom: "20px" }}>
                  <MDBIcon icon="check-circle" className="mr-1" />Todos los trabajadores ya firmaron su declaración.
                </p>
              ) : (
                <p style={{ fontSize: "0.87rem", color: "#555", marginBottom: "20px" }}>
                  ¿Desea enviar un recordatorio a los <strong style={{ color: "#E65100" }}>{this.state.modalEstadoRecordatorio.pendientes} trabajadores</strong> que aún no firmaron?
                </p>
              )}

              <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                <button
                  onClick={function () { this.setState({ modalEstadoRecordatorio: null }); }.bind(this)}
                  style={{ background: "#fff", color: "#666", border: "1px solid #ccc", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  Cerrar
                </button>
                {this.state.modalEstadoRecordatorio.pendientes > 0 && (
                  <button
                    onClick={this.confirmarEnvioRecordatorio.bind(this)}
                    style={{ background: "#E65100", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                    <MDBIcon icon="paper-plane" className="mr-2" />Enviar Recordatorio
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal Resultado Recordatorio */}
        {this.state.resultadoRecordatorio && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              {this.state.resultadoRecordatorio.ok ? (
                <>
                  <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fff3e0", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <MDBIcon icon="bell" style={{ color: "#E65100", fontSize: "2rem" }} />
                  </div>
                  {this.state.resultadoRecordatorio.enviados === 0 ? (
                    <p style={{ fontSize: "1rem", fontWeight: "700", color: "#2E7D32", marginBottom: "20px" }}>
                      <MDBIcon icon="check-circle" className="mr-2" />
                      {this.state.resultadoRecordatorio.mensaje || "Todos los trabajadores ya firmaron su declaración."}
                    </p>
                  ) : (
                    <p style={{ fontSize: "1rem", fontWeight: "700", color: "#E65100", marginBottom: "20px" }}>
                      Recordatorio enviado a <span style={{ fontSize: "1.4rem" }}>{this.state.resultadoRecordatorio.enviados}</span> de {this.state.resultadoRecordatorio.total} trabajadores pendientes.
                    </p>
                  )}
                </>
              ) : (
                <>
                  <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fdecea", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <MDBIcon icon="exclamation-triangle" style={{ color: "#C62828", fontSize: "2rem" }} />
                  </div>
                  <p style={{ fontSize: "1rem", fontWeight: "700", color: "#C62828", marginBottom: "20px" }}>Error: {this.state.resultadoRecordatorio.error}</p>
                </>
              )}
              <button
                onClick={function () { this.setState({ resultadoRecordatorio: null }); }.bind(this)}
                style={{ background: "#E65100", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Cerrar
              </button>
            </div>
          </div>
        )}

        {/* Modal Error */}
        {this.state.modalError && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fdecea", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="exclamation-triangle" style={{ color: "#C62828", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1.05rem", fontWeight: "700", color: "#C62828", marginBottom: "20px" }}>{this.state.modalError}</p>
              <button onClick={function () { this.setState({ modalError: "" }); }.bind(this)}
                style={{ background: "#7A1622", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Cerrar
              </button>
            </div>
          </div>
        )}

      </div>
    );
  }
}

export default AdminDeclaracionesJuradas;
